import React from "react";

const Events = () => {
  return (
    <>
      {/* Page Title */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-events.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Events</h1>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Events</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section className="portfolio-details-style01">
        <div className="container">
          <div className="col-lg-12">
            <div>
              {/* Commemorating the Sacred Abirbhab Tithi of Prabhuji */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                <img
                  src="img/portfolio/evnt-2.jpg"
                  alt="Abirbhab Tithi"
                  className="border-radius-10"
                />
              </div>
              <div className="row mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Commemorating the Sacred Abirbhab Tithi of Prabhuji
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">1</span>With hearts filled with devotion and reverence, Shamayita Convent School observed the sacred Abirbhab Tithi of our beloved and revered Prabhuji. The campus echoed with divine hymns and spiritual melodies, while students presented graceful and soulful dance performances expressing their faith and gratitude. The celebration created a vibrant and spiritually uplifting atmosphere, making the occasion grand, memorable, and filled with divine bliss.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-4 wow fadeIn" data-wow-delay="100ms" key={i}>
                    <div className="image-hover">
                      <img
                        src={`img/portfolio/evnt-${i + 3}.jpg`}
                        alt={`Abirbhab Tithi ${i + 1}`}
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Kherwal Tukou is the Tribal Way of Welcoming the New Year */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                <img
                  src="img/portfolio/evnt-1.jpg"
                  alt="Kherwal Tukou"
                  className="border-radius-10"
                />
              </div>
              <div className="row mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Kherwal Tukou is the Tribal Way of Welcoming the New Year
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">2</span>Shamayita Math marked the beginning of the new year (2026) with the Kherwal Tukou event, bringing together over 40,000 people in Shiulibona village, Bankura, West Bengal, to celebrate culture and togetherness.
                    </p>
                    <p className="mb-2">
                      Held on 31st December 2025 – 1st January 2026, the two-day celebration beautifully showcased the rich cultural heritage of tribal communities through tribal dances, Baul songs, folk poetry, and a lively rural fair. The festival reflected the deep bond of harmony, amity, and respect that tribal life shares with Mother Nature.
                    </p>
                    <p className="mb-2">
                      The performances on 1st January captivated the audience with energetic Rinja, Pata, Danshai, Santhali, Raibeshe, and Ranpa folk dances, along with soulful Baul songs by Baul Bamacharan from Birbhum.
                    </p>
                    <p className="mb-0">
                      Special attractions such as the village fair, exhibition, and open-air community lunch brought people together, making the festival a shared experience of joy and togetherness.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-4 wow fadeIn" data-wow-delay="100ms" key={i}>
                    <div className="image-hover">
                      <img
                        src={`img/portfolio/evnt-${i + 6}.jpg`}
                        alt={`Kherwal Tukou ${i + 1}`}
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Celebrating 28 Years of Service and Commitment */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp pt-5" data-wow-delay="100ms">
                <img
                  src="img/portfolio/evnt-9.jpg"
                  alt="28 Years Anniversary"
                  className="border-radius-10"
                />
              </div>
              <div className="row mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9 pt-4">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Celebrating 28 Years of Service and Commitment
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">3</span>Our annual conference on November 16th, 2025 brought over 6,000 people together in Bankura. It began with a flag hoisting by Sri Sri Prabhuji. From cultural performances to honest reflections, the day celebrated 28 years of Shamayita Math and the strength of the communities we have worked with.
                    </p>
                    <p className="mb-2">
                      Stalls were also set up, highlighting our work in education, healthcare, agriculture and more. The day ended with a shared meal (prashad) - and a firm resolve to continue on this path of our shared journey with the community.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-4 wow fadeIn" data-wow-delay="100ms" key={i}>
                    <div className="image-hover">
                      <img
                        src={`img/portfolio/evnt-${i + 10}.jpg`}
                        alt={`Anniversary Celebration ${i + 1}`}
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Bastradaan on Sharadiya Utsav */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp pt-5" data-wow-delay="100ms">
                <img
                  src="img/portfolio/evnt-13.jpg"
                  alt="Bastradaan on Sharadiya Utsav"
                  className="border-radius-10"
                />
              </div>
              <div className="row mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9 pt-4">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Bastradaan on Sharadiya Utsav
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">4</span>In October 2025, the Sharadiya Utsav was celebrated with the spirit of compassion and sharing through the Bastradaan Utsav. At Shamayita Convent School, students from Hanspahari, Shiulibona, and Kendrabona Thole Primary Schools participated in the Sarod Bāran Utsav with vibrant performances of drama, songs, and dances. The day was enriched with the distribution of study materials, clothes, sweets, and ice creams, creating moments of joy and learning for the children. Extending the celebration beyond the school, clothes were distributed to nearly 2,000 people across 65 villages in Gangajalghati Block of Bankura District. The Bastradaan Utsav became a meaningful festival of sharing, learning, and togetherness, nurturing hope for a brighter tomorrow.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-4 wow fadeIn" data-wow-delay="100ms" key={i}>
                    <div className="image-hover">
                      <img
                        src={`img/portfolio/evnt-${i + 14}.jpg`}
                        alt={`Bastradaan ${i + 1}`}
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default Events;